import { Component, inject, Inject } from '@angular/core';
import { NZ_MODAL_DATA, NzModalModule, NzModalRef } from "ng-zorro-antd/modal";
import { PdfViewerModule } from "ng2-pdf-viewer";
import { NzButtonModule } from "ng-zorro-antd/button";
import { PercentPipe } from "@angular/common";
import { NzIconModule } from "ng-zorro-antd/icon";

@Component({
  selector: 'app-pdf-view-modal',
  imports: [
    PercentPipe,
    NzModalModule,
    NzButtonModule,
    NzIconModule,
    PdfViewerModule
  ],
  template: `
    <div class="pdf-controls">
      <button (click)="zoomIn()">
        <nz-icon nzType="zoom-in" nzTheme="outline" />
      </button>
      <span style="margin: 0 6px; width: 18px">{{ zoom | percent }}</span>
      <button (click)="zoomOut()">
        <nz-icon nzType="zoom-out" nzTheme="outline" />
      </button>

      <button (click)="setZoom(1)">Сбросить</button>

      <button (click)="rotate()">
        <nz-icon nzType="rotate-right" nzTheme="outline" />
      </button>
    </div>

    <div class="pdf-viewer-container">
      <pdf-viewer [src]="downloadUrl" [show-all]="true" [zoom]="zoom" [rotation]="rotation" style="width: 100%; height: 85vh"></pdf-viewer>
    </div>
    <div *nzModalFooter>
      <button type="button" nz-button nzType="default" (click)="onCancel()">Закрыть</button>
    </div>
  `,
  styles: `
    .pdf-controls {
      text-align: center;
      font-size: 14px;

      background-color: lightgray;
    }

    .pdf-controls button {
      background: none;
      border: none;
      cursor: pointer;

      &:hover {
        background: #b7b7b7;
        border-radius: 8px;
        transition: 0.1s ease;
      }
    }
  `,
})
export class PdfViewModalComponent {
  private modal = inject(NzModalRef);

  zoom = 1;
  rotation = 0;

  constructor(@Inject(NZ_MODAL_DATA) public downloadUrl: string) {}

  onCancel(): void {
    this.modal.destroy();
  }

  zoomIn() {
    this.zoom += 0.1;
  }

  zoomOut() {
    if (this.zoom > 0.2) this.zoom -= 0.1;
  }

  setZoom(value: number) {
    this.zoom = value;
    this.rotation = 360
  }

  rotate() {
    this.rotation = (this.rotation + 90) % 360;
  }
}
